module.exports = __webpack_public_path__ + "static/media/management.998f0563.svg";